import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { StatusCodes } from "http-status-codes";
import { Plan, VEBPlan } from "../../../@types/plan.types";

const { post, get, put, del, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "plan-design";

export const addPlanDesignForm = async (payload: FormData): Promise<any> => {
	try {
		const endpoint = `${initialRoute}`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		}
		throw error;
	}
};

const updatePlanDesignForm = async (payload: FormData): Promise<any> => {
	try {
		const endpoint = `${initialRoute}`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		}
		throw error;
	}
};

export const planDesign = {
	addPlanDesignForm,
	updatePlanDesignForm
};
